export let baseUrl = "";

if (process.env.NODE_ENV !== "production") {
  baseUrl = "http://localhost:8080";
  console.log(process.env.REACT_APP_API_URL);
} else {
  baseUrl = process.env.REACT_APP_API_URL;
}

export const jsonParser = (res) => {
  if (res.status === 200 || res.status === 201) {
    return res.text().then((t) => {
      try {
        return JSON.parse(t);
      } catch (e) {
        return null;
      }
    });
  } else {
    throw res;
  }
};

const secured = (url, params = {}) => {
  if (localStorage.apiToken && localStorage.apiToken !== "null") {
    params.headers = Object.assign({}, params.headers, {
      Authorization: `Bearer ${localStorage.apiToken}`,
    });
  }
  return fetch(baseUrl + url, params);
};

export const get = (url, params = {}) => {
  params.method = "GET";
  return secured(url, params);
};

export const del = (url, params = {}) => {
  params.method = "DELETE";
  return secured(url, params);
};

export const post = (url, params = {}) => {
  params.method = "POST";
  params.headers = Object.assign({}, params.headers, {
    "Content-Type": "application/json",
  });
  params.body = JSON.stringify(params.body);
  return secured(url, params);
};

export const upload = (url, params = {}) => {
  params.method = "POST";
  return secured(url, params);
};

export const put = (url, params = {}) => {
  params.method = "PUT";
  params.headers = Object.assign({}, params.headers, {
    "Content-Type": "application/json",
  });
  params.body = JSON.stringify(params.body);
  return secured(url, params);
};

export const form = (url, params = {}) => {
  params.method = "POST";
  params.headers = Object.assign({}, params.headers, {
    "Content-Type": "application/x-www-form-urlencoded",
    "Bypass-Tunnel-Reminder": "teste",
  });
  var pair = [];
  Object.keys(params.body).forEach((k) => pair.push(k + "=" + params.body[k]));
  params.body = pair.join("&");
  return fetch(baseUrl + url, params);
};
